/**
 * Census estimate year N covers July 1 (N-1) through June 30 (N).
 */
export function periodLabel(year: number): string {
  return `${year - 1}–${String(year).slice(2)}`;
}

export function periodRangeLabel(year: number): string {
  return `July ${year - 1} – June ${year}`;
}

/** Short axis-style label for slider marks: 2024 -> "'24". */
export function periodTick(year: number): string {
  return `’${String(year).slice(2)}`;
}

/** 2341876 -> "2.34M", 41200 -> "41.2K" */
export function compactNumber(value: number): string {
  const abs = Math.abs(value);
  const sign = value < 0 ? '−' : '';
  if (abs >= 1_000_000) return `${sign}${(abs / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `${sign}${(abs / 1_000).toFixed(1)}K`;
  return `${sign}${abs.toLocaleString()}`;
}
